import { useState } from 'react';
import cn from 'classnames';
import { IMenuItem } from 'models/IMenuItem';
import { chunks } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { NotifyLink } from 'components/Shared/NotifyLink';
import { IconCaret } from 'components/Shared/Icon/themes/PP/iconCaret';
import { Advice, Contact } from './adviceAndContact';
import styles from './category.scss';
import { GtmHeaderNavClick } from 'store/googleTagManager/actions';
import { useDispatch } from 'react-redux';

interface CategoryProps {
  subCategories?: IMenuItem['subCategories'];
}

export const Category = ({ subCategories }: CategoryProps) => {
  const reduxDispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = useState<string>();
  const openCategory = (categoryId: string) => () => setSelectedCategory(categoryId);

  const subCategory = subCategories && subCategories.find(sub => sub.id === selectedCategory);
  const twoColumns = !!(
    subCategory &&
    subCategories &&
    subCategory.subCategories.length > subCategories.length
  );
  const subCategoryColumns = subCategory && getSubCategoryColumns(subCategory, twoColumns);

  const showAdviceAndContact = !!selectedCategory || !subCategories;

  const handleOnClick = (url: string) => {
    reduxDispatch(GtmHeaderNavClick(url));
  };

  return (
    <div className={styles.menuContainer}>
      <div className={styles.menu}>
        {subCategories && (
          <div className={styles.column}>
            {subCategories.map(category => (
              <SubCategory
                key={category.id}
                onNavItemClick={handleOnClick}
                category={category}
                openCategory={openCategory}
                selectedCategory={selectedCategory}
              />
            ))}
          </div>
        )}

        {subCategoryColumns && (
          <>
            {subCategoryColumns.map((column, i) => (
              <div key={i} className={styles.column}>
                {column.map(sub => (
                  <NotifyLink
                    ticket={sub.ticket}
                    onClick={() => handleOnClick(sub.url)}
                    url={sub.url}
                    key={sub.id}
                    className={styles.category}
                    {...getQaDataAttr(`link-nav-${sub.id}`)}
                  >
                    {sub.title}
                  </NotifyLink>
                ))}
              </div>
            ))}
          </>
        )}
      </div>

      {showAdviceAndContact && (
        <div className={styles.adOrContactWrapper}>
          <Advice />
          <Contact />
        </div>
      )}
    </div>
  );
};

const two = 2;
function getSubCategoryColumns(subCategory: IMenuItem, twoColumns: boolean): IMenuItem[][] {
  const chunkSize = twoColumns
    ? subCategory.subCategories.length / two
    : subCategory.subCategories.length;

  return chunks(subCategory.subCategories, chunkSize);
}

interface SubCategoryProps {
  category: IMenuItem;
  openCategory: (categoryId: string) => () => void;
  selectedCategory: string | undefined;
  onNavItemClick: (url: string) => void;
}
const SubCategory = ({
  category,
  openCategory,
  selectedCategory,
  onNavItemClick
}: SubCategoryProps) => {
  const { id, url, title, ticket } = category;
  const isOpen = id === selectedCategory;

  return (
    <>
      <NotifyLink
        className={cn(styles.category, {
          [styles.selected]: isOpen
        })}
        onClick={() => onNavItemClick(url)}
        onMouseEnter={openCategory(id)}
        url={url}
        ticket={ticket}
        {...getQaDataAttr(`link-nav-${id}`)}
      >
        <span>{title}</span>
        <IconCaret
          className={cn(styles.icon, {
            [styles.visible]: isOpen
          })}
          size="tiny"
        />
      </NotifyLink>
    </>
  );
};
